module.exports = __webpack_public_path__ + "static/media/asuka.52c3e815.png";